import React, { Fragment } from "react";
import { print } from "graphql";
import { Mutation } from "@apollo/client/react/components";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";
import SimpleModal from "../../SimpleModal";
import SimpleForm from "../../SimpleForm";
import inputResolver from "../../SimpleForm/FieldResolver";
import UISchemaResolver from "../../../data/schema/form_ui/_resolver";
import PrefillUtil from "../../../global/utils/prefillHelper";
import GQLUtil from "../../../global/utils/gqlHelper";
import util from "../../Utils/mappers";
import FormExit from "../../SimpleForm/UI/FormExit";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { connect } from "react-redux";
import renderDeleteButton from "../renderDeleteButton";
import {
  GET_790V2_FORM_DATA,
  GET_790AV2_PROFILES,
  SUBMIT_790V2_FORM,
  UPDATE_790V2_FORM,
} from "../Form790V2/queries";
import renderSaveButton from "../renderSaveButton";
import renderFormActions from "../renderFormActions";
import { cleanData, validateOnLoad } from "./helpers";
import isTester from "../../SimpleForm/SubmissionUtilities/isTester";
import FullScreenSpinner from "../../../global/components/FullScreenSpinner";
import { fetchAllReferenceData } from "../../../global/app/actions/actions_reference";

class Form790V2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closeModal: false,
      modalOpen: true,
      formSubmitting: false,
      profiles: [],
      counties: undefined,
      formData:
        (this.props.history.location.state &&
          this.props.history.location.state.initialValues) ||
        {},
      form_ui: undefined,
      reuse:
        (this.props.history.location.state &&
          this.props.history.location.state.reuse) ||
        false,
    };
  }

  componentDidMount = async () => {
    const application_type = "790A";
    const application_id = this.props.match.params.id;

    // if user is currently in app and reference data updates we want to fetch latest data when they open up the form
    // before we were checking if data existed in redux and if so skipping the fetch and not getting the latest data
    this.props.dispatch(fetchAllReferenceData());

    const profiles = await GQLUtil.genericGQLQuery(print(GET_790AV2_PROFILES));

    // Convert profiles to V2
    profiles.data.getUserProfileInfo.MaterialTermsProfiles =
      profiles?.data?.getUserProfileInfo?.MaterialTermsProfiles?.filter(
        (profile) => {
          const V2Options = [
            // V2 names
            "Job Duties",
            "Pay Deductions",
            "Job Requirements",
            "Meal Provision",
            "Daily Transportation",
            "Inbound/Outbound Transportation",
            "Referral and Hiring Instructions",
            // V3 names
            "Deductions from Pay",
            "Job Qualifications/Requirements",
            "Provision of Meals",
          ];
          return V2Options.includes(profile?.material_terms_section_number);
        }
      ).map((profile) => {
        const convertToV2 = {
          "Provision of Meals": "Meal Provision",
          "Job Qualifications/Requirements": "Job Requirements",
          "Deductions from Pay": "Pay Deductions",
        };

        if (!!convertToV2[profile?.material_terms_section_number]) {
          profile.material_terms_section_number =
            convertToV2[profile?.material_terms_section_number];
        }

        return profile;
      });
    const profiles_parsed = PrefillUtil.getPrefillProfileOptions(
      profiles.data.getUserProfileInfo,
      application_type,
      "all"
    );

    util
      .getCounties()
      .then((data) => this.setState({ counties: data }))
      .catch((e) => {
        console.log(`unable to fetch counties`);
      });

    const form = await GQLUtil.genericGQLQuery(print(GET_790V2_FORM_DATA), {
      id: application_id,
    });
    let formData = form.data?.getForm790AV2ById?.payload;
    let formVersionId = form.data.getForm790AV2ById.formVersionId;
    if (form.data !== null) {
      let form_ui = form.data.getForm790AV2ById.form_ui;
      this.setState({
        profiles: profiles_parsed,
        form_ui,
      });
      if (formData) {
        if (!formData?.formVersionId) formData["formVersionId"] = formVersionId;
        this.setState({
          formData,
        });
      } else {
        // On initial form creation, form data is null but we still want to set the form version to 2
        // This is in case there is any visibility depedent content.
        this.setState({
          formData: { formVersionId },
        });
      }
    }

    /**
     * ! 790A Reuse
     * ! This is an important step in reuse where the values come back here to be injected into formData class state.
     * ! The values are then sent downstream into SimpleForm.
     *
     * On initial reuse we import from history object but subsequent updates we do not.
     * If payload data from cosmos comes back we use that instead.
     */
    if (
      this.props.history.location.state &&
      this.props.history.location.state.initialValues
    ) {
      this.setState({
        formData: {
          ...this.props.history.location.state.initialValues,
          ...(formData ?? {}),
          formVersionId,
        },
      });
    }
  };

  render790 = () => {
    const application_type = "790AV2";
    const resolverName = "SubmitForm790AV2";
    const application_id = this.props.match.params.id;
    const useRecaptcha = this.props.user?.Recaptcha !== false;
    const { executeRecaptcha } = useRecaptcha
      ? this.props.googleReCaptchaProps
      : {};

    const handleToggle = () => {
      this.setState({ closeModal: !this.state.closeModal });
    };
    const renderFormExit = (values, form_ui, form_ui_name) => {
      return (
        <FormExit
          renderDeleteButton={() =>
            renderDeleteButton(
              application_id,
              application_type,
              this.props.history,
              undefined,
              this.props.user.GroupRole
            )
          }
          renderSaveButton={() =>
            renderSaveButton(
              UPDATE_790V2_FORM,
              values,
              "Form790AV2FormData",
              application_id,
              cleanData,
              this.props.history,
              "Save as Initiated",
              undefined,
              undefined,
              form_ui,
              form_ui_name
            )
          }
          closeModal={this.state.closeModal}
          toggleModal={handleToggle}
          values={values}
        />
      );
    };

    const setFormSubmittingState = (booleanValue) => {
      this.setState({ formSubmitting: booleanValue });
    };

    const formSubmissionError = (e, application_id) => {
      setFormSubmittingState(false);
      let type;
      let error = JSON.stringify(e);
      if (
        e &&
        e.graphQLErrors &&
        e.graphQLErrors[0] &&
        e.graphQLErrors[0].extensions
      ) {
        error = e.graphQLErrors[0].extensions;
      }
      if (
        e &&
        e.graphQLErrors &&
        e.graphQLErrors[0] &&
        e.graphQLErrors[0].message
      ) {
        type = e.graphQLErrors[0].message;
      }
      this.props.history.push({
        pathname: "/dashboard/error",
        state: {
          application_id,
          formType: application_type,
          error,
          type,
        },
      });
    };

    const formSubmissionSuccess = (res) => {
      const queueError = res?.[`${resolverName}`] === "queue_error";
      setFormSubmittingState(false);
      this.props.history.push({
        pathname: "/dashboard/success",
        state: { formType: application_type, queueError },
      });
    };

    return (
      <Fragment>
        {!this.state.modalOpen ? (
          <Redirect to="/dashboard/application" />
        ) : (
          <SimpleModal
            fullscreen={true}
            toggleModal={handleToggle}
            modalStatus={this.state.modalOpen}
          >
            <Mutation
              mutation={SUBMIT_790V2_FORM}
              onError={(e) => formSubmissionError(e, application_id)}
              onCompleted={(e) => formSubmissionSuccess(e)}
            >
              {(SubmitForm790AV2) => (
                <SimpleForm
                  handleSubmit={
                    useRecaptcha
                      ? async (values) => {
                          if (!executeRecaptcha) {
                            return;
                          }
                          const token = await executeRecaptcha(resolverName);
                          setFormSubmittingState(true);
                          SubmitForm790AV2({
                            variables: {
                              Form790AV2FormData: cleanData(values),
                              id: application_id,
                              token,
                            },
                          });
                        }
                      : (values) => {
                          setFormSubmittingState(true);
                          SubmitForm790AV2({
                            variables: {
                              Form790AV2FormData: cleanData(values),
                              id: application_id,
                            },
                          });
                        }
                  }
                  toggleClose={handleToggle}
                  toggleModal={handleToggle}
                  formExit={this.state.closeModal}
                  renderFormExit={renderFormExit}
                  renderFormActions={renderFormActions(
                    UPDATE_790V2_FORM,
                    "Form790AV2FormData",
                    application_id,
                    cleanData,
                    this.props.history,
                    this.state.formSubmitting
                  )} // override default FormActions
                  formSaveMutation={UPDATE_790V2_FORM}
                  formSaveMutationCallback={({
                    formValues,
                    formUIData,
                    saveForm,
                    profilePrefillMetadata,
                  }) => {
                    saveForm({
                      variables: {
                        formUI790A: formUIData,
                        Form790AV2FormData: cleanData(formValues),
                        id: application_id,
                        profilePrefillMetadata: profilePrefillMetadata.profiles,
                      },
                    });
                  }}
                  multiPage={true}
                  uiSchema={UISchemaResolver(
                    application_type,
                    this.props.referenceData?.mealCharges && {
                      mealCharges: this.props.referenceData.mealCharges,
                    }
                  )}
                  uiSchema_meta={UISchemaResolver(`${application_type}-meta`)}
                  uiSchema_nav={UISchemaResolver(`${application_type}-nav`)}
                  uiSchema_lookup={UISchemaResolver(
                    `${application_type}-lookup`
                  )}
                  inputResolver={inputResolver}
                  initialValues={this.state.formData}
                  profiles={this.state.profiles}
                  counties={this.state.counties}
                  form_ui={this.state.form_ui}
                  form_ui_name={"formUI790A"}
                  formSubmitting={this.state.formSubmitting}
                  returningToForm={this.state.reuse}
                  validateOnLoad={validateOnLoad}
                  disableValidation={
                    (this.props.user &&
                      this.props.user.Roles &&
                      isTester(this.props.user && this.props.user.Roles)) ||
                    false
                  }
                />
              )}
            </Mutation>
          </SimpleModal>
        )}
      </Fragment>
    );
  };

  render() {
    if (this.state.formData !== undefined && this.state.form_ui !== undefined) {
      return <div>{this.render790()}</div>;
    }
    return <FullScreenSpinner />;
  }
}

const mapStateToProps = (state) => ({
  user: state.appReducer.userDataReducer.data,
  referenceData: state.referenceReducer,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const ConnectedForm = connect(mapStateToProps, mapDispatchToProps)(Form790V2);
const RoutedForm = withRouter(ConnectedForm);

const FormWrapper = (props) => {
  const useRecaptcha = props.user?.Recaptcha !== false;
  const ComponentToRender = useRecaptcha
    ? withGoogleReCaptcha(RoutedForm)
    : RoutedForm;

  return <ComponentToRender {...props} />;
};

export default FormWrapper;
